export { default } from "./useWritePromptPost";
